import { CloudServerOutlined } from '@ant-design/icons'

const FileShare = ({ ...props }) => {
  return <CloudServerOutlined className="text-[20px] cursor-pointer ml-0" {...props} />
}

export default FileShare
